import React, { createContext, useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { useAlert } from '../../alert/containers/AlertProvider'
import {
  getTrashTypesApi,
  getNaturesApi,
  getAssignedComplaintListApi,
  startProcessingComplaintApi,
  processedComplaintApi,
  resetComplaintStatusApi,
  returnComplaintApi,
  uploadImageApi
} from '../api'
import { getComplaintOperationListApi } from '../../complaint/api'
import 'moment/locale/fr'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../security/containers/AuthProvider'

moment.locale('fr')

const config = {
  bucketName: 'ndif-n2s-cloud',
  dirName: 'Uploads',
  region: 'eu-central-1',
  accessKeyId: process.env.ACCESS_KEY_ID,
  secretAccessKey: process.env.SECRET_ACCESS_KEY,
}

  export const AssignComplaintsContext = createContext()

  export const initialFilter = {
    id: 0, // mem
    orderBy: 0,
    natureIds: [],
    trashTypeIds: [],
    date: {
      startDate: null,
      endDate: null,
    },
    statuses: [],
    wilayas: [],
    communes: [],
    startTime: '00:00',
    endTime: '23:59',
    ownerPhoneNumber: '',
    // mem
    dairaId:[],
  }

  export const initialOperationFilter = {
    take: 0,
    skip: 0,
  }

  const initialOperationPagination = { currentPage: 0, take: 10, skip: 0, total: 0 }
  const initialPagination = { currentPage: 0, take: 10, skip: 0, total: 0 }

  const initialPaginationComplaint = { id: 0 }

export const AssignComplaintsProvider = ({children}) => {
  const { showAlert } = useAlert()
  const { me } = useAuth()
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)

  const [assignedComplaintList, setAssignedComplaintList] = useState([])
  const [trashTypes, setTrashTypes] = useState([])
  const [natures, setNatures] = useState([])

  const [operationPagination, setoperationPagination] = useState(initialOperationPagination)
  const [operationFilter, setOperationFilter] = useState(initialOperationFilter)
  const [pagination, setPagination] = useState(initialPagination)
  const [filter, setFilter] = useState(initialFilter)

  const [complaintIdFP, setcomplaintIdFP] = useState(initialPaginationComplaint)
  const [complaintOperationList, setComplaintOperationList] = useState([])

  const handleOperationPagination = ({
    take = operationPagination.take,
    skip = operationPagination.skip,
    currentPage = operationPagination.currentPage,
  }) => {
    // console.log('look here updating take: ' + take + " and skip: " + skip)
    setoperationPagination({ ...operationPagination, take, skip, currentPage })
  }

  const handleOperationFilter = (newOperationFilter) => {
    handleOperationPagination({ currentPage: 0, skip: 0 })
    setOperationFilter(newOperationFilter)
  }

  const handlePagination = ({
      take = pagination.take,
      skip = pagination.skip,
      currentPage = pagination.currentPage,
    }) => {
      setPagination({ ...pagination, take, skip, currentPage })
    }

  const handleFilter = (newFilter) => {
      handlePagination({ currentPage: 0, skip: 0 })
      setFilter(newFilter)
  }

  const handleOperationPaginationRefresh = ({
    id = complaintIdFP.id,
  }) => {
    setcomplaintIdFP({ ...complaintIdFP, id })
  }
  
  const getTrashTypes = async () => {
    try {
      setIsLoading(true)
      const { data } = await getTrashTypesApi()
      setTrashTypes(data)
    } catch {
      if( me?.roles === "intervenant") {
        showAlert({
          variant: 'success',
          message: 'Bienvenue Intervenant',
        })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue') })
      }
    } finally {
      setIsLoading(false)
    }
  }
  
  const getNatures = async () => {
    try {
      setIsLoading(true)
      const { data } = await getNaturesApi()
      setNatures(data)
    } catch {
      if( me?.roles === "intervenant") {
        showAlert({
          variant: 'success',
          message: 'Bienvenue Intervenant',
        })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue') })
      }
    } finally {
      setIsLoading(false)
    }
  }

  const getComplaintOperationList = async () => {
    try {
      // edit here
      
      const { take, skip } = operationPagination
      const {id} = complaintIdFP
      setIsLoading(true)
      
      const { data, headers } = await getComplaintOperationListApi({ complaintId:id, take, skip })
      
      setComplaintOperationList(data)
      
      setoperationPagination({ ...operationPagination, total: headers['x-total-count'] })
    }
    catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } 
    finally {
      setIsLoading(false)
    }
  }
  
  const getAssignedComplaintList = async () => {
    try {
      const {
        id, // mem
        natureIds,
        trashTypeIds,
        wilayas,
        communes,
        date,
        ownerPhoneNumber,
        statuses,
        orderBy,
        startTime,
        endTime,
        // mem
        dairaId,
      } = filter
      const { take, skip } = pagination
      setIsLoading(true)

      const requestFilter = {
        ...(id.length > 0 && { id }), // mem
        natureIds,
        trashTypeIds,
        communeIds: communes.map(({ id }) => id),
        // mem
        dairaIds: dairaId.map(({ id }) => id),
        //
        wilayaIds: communes.length === 0 ? wilayas.map(({ id }) => id) : [],
        orderBy,
        statuses,
        ...(date.startDate !== null && {
          startDate: moment(
            `${date.startDate.format('YYYY-MM-DD')} ${startTime}`,
          ).format(),
        }),
        // add 59 second to end time
        ...(date.endDate !== null && {
          endDate: moment(
            `${date.endDate.format('YYYY-MM-DD')} ${endTime}:59`,
          ).format(),
        }),
        ...(ownerPhoneNumber.length > 3 && { ownerPhoneNumber }),
        take,
        skip,
      }
      const { data, headers } = await getAssignedComplaintListApi({
        filter: requestFilter,
      })

      // here edit
      // let sortedArrayByLO = await data.sort((element1, element2) => (new Date(element2.lastOperationDate)) - (new Date(element1.lastOperationDate)) )
      
      let data2 = data.map( async element => {
        if (element.status === 7) {
          let { data } = await getComplaintOperationListApi({ complaintId:element.id, take:1, skip:1 })
          if (data.length > 0)  return {...element, prevStatus: data[0].status}
          else  return {...element, prevStatus: 0}
        }
        else  return element
      })

      Promise.all(data2).then((data) => {
        setAssignedComplaintList(data)
      })

      // setAssignedComplaintList(sortedArrayByLO)

      setPagination({ ...pagination, total: headers['x-total-count'] })
    } catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  const returnComplaint = async (complaintId, comment) => {
    try {
      setIsLoading(true)

      await returnComplaintApi({complaintId, comment})
      returnedComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: t('showAlert.la_reclamation_a_bien_ete_retournee'),
      })
    } catch (e) {
      if (e?.response?.data?.errorCode === 'DuplicateUserName') {
        showAlert({ message: t('showAlert.cette_reclamation_est_deja_retournee')})
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    } finally {
      setIsLoading(false)
    }
  }
  
  const startProcessingComplaint = async ({complaintId, timeLimit}) => {
    try {
      setIsLoading(true)

      await startProcessingComplaintApi({complaintId, timeLimit})
      processingComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: t('showAlert.le_statut_de_traitement_a_bien_ete_envoyee'),
      })
    } catch (e) {
      if (e?.response?.data?.errorCode === 'DuplicateUserName') {
        showAlert({ message: t('showAlert.cet_assignement_a_deja_commence_a_etre_traite')})
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    } finally {
      setIsLoading(false)
    }
  }
  
  const processedComplaint = async (complaintId, pictureLinks) => {
    try {
      setIsLoading(true)

      const promises = pictureLinks.map((pictureLink) => {
        let formData = new FormData();
        formData.append('files', pictureLink);
        return uploadImageApi(formData).then((response) => {
          return response.data
        })
      })
      Promise.all(promises).then((response) => {
        pictureLinks = response
        processedComplaintApi(complaintId, pictureLinks)
        processedComplaintStatus({
          id: complaintId,
        })
        showAlert({
          variant: 'success',
          message: t('showAlert.le_statut_de_traitement_a_bien_ete_envoyee'),
        })
      })
      
    } catch(error) {
      if (error?.response?.data?.errorCode === 'FileTooLarge') {
          showAlert({ message: t('showAlert.imageSizeTooLarge') })
      }
      else {
          if (error?.response?.data?.errorCode === 'FileNotAnImage') {
              showAlert({ message: t('showAlert.fileNotImage') })
          }
          else {
              if (error?.response?.data?.errorCode === 'FileNotFound') {
                  showAlert({ message: t('showAlert.fileNotFound') })
              }
              else {
                  showAlert({ message: t('showAlert.une_erreur_est_survenue') })
              }
          }
      }
    }
    finally {
      setIsLoading(false)
    }
  }

  // const processedComplaint = async ({complaintId, pictureLink}) => {
  //   try {
  //     setIsLoading(true)

  //     let formData = new FormData();
  //     formData.append('files', pictureLink);

  //     uploadImageApi(formData).then((response) => {
  //     pictureLink = response.data
  //     processedComplaintApi({complaintId, pictureLink})
  //       processedComplaintStatus({
  //         id: complaintId,
  //       })
  //       showAlert({
  //         variant: 'success',
  //         message: t('showAlert.le_statut_de_traitement_a_bien_ete_envoyee'),
  //       })
  //     })
      
  //   } catch(error) {
  //     if (error?.response?.data?.errorCode === 'FileTooLarge') {
  //         showAlert({ message: t('showAlert.imageSizeTooLarge') })
  //     }
  //     else {
  //         if (error?.response?.data?.errorCode === 'FileNotAnImage') {
  //             showAlert({ message: t('showAlert.fileNotImage') })
  //         }
  //         else {
  //             if (error?.response?.data?.errorCode === 'FileNotFound') {
  //                 showAlert({ message: t('showAlert.fileNotFound') })
  //             }
  //             else {
  //                 showAlert({ message: t('showAlert.une_erreur_est_survenue') })
  //             }
  //         }
  //     }
  //   }
  //   finally {
  //     setIsLoading(false)
  //   }
  // }

  const uploadPresignedFileApi = async ( presignedUrl, uri, fileType ) => {
    const resp = await fetch(uri)
    const body = await resp.blob()
    Object.defineProperty(body, 'type', {
      value: fileType,
      writable: false,
    })
    return await fetch(presignedUrl, { method: 'PUT', body })
  }

    

  // const uploadImageUriBase = async(uri) => {
  //   try{
  //     const fileType = `image/jpeg`

  //     const {data} = await fetchPresignedUrlApi([fileType])
  //     const {fileName, presignedUrl} = data[0]
  //     console.log('fileName inside uploadImageUrlBase: ' ,fileName)
  //     console.log(uri)
  //     console.log('URI NAME:',uri.name)

  //     Object.defineProperty(uri, 'name', {
  //       value: fileName,
  //       writable: false,
  //     }) 
  //     Object.defineProperty(uri, 'type', {
  //       value: fileType,
  //       writable: false,
  //     })
  //     console.log('newURI: ', uri)
  //     return  fileName
  //   } catch {
  //     showAlert({ message: t('showAlert.une_erreur_est_survenue') })
  //   }
  // }


    // const changeAssignedComplaintStatus = async ({ complaintsIds, statusType }) => {
    //   const newStatusTypes = await Promise.all(
    //     complaintsIds.map((id) =>
    //       changeComplaintStatusApi({
    //         id,
    //         statusType,
    //       }),
    //     ),
    //   )
  
    //   setAssignedComplaintList(
    //     assignedComplaintList.map((complaint) => {
    //       if (complaintsIds.indexOf(complaint.id) !== -1) {
    //         // use newStatusTypes[0].data because all statuses are the same
    //         return { ...complaint, status: newStatusTypes[0].data }
    //       }
    //       return complaint
    //     }),
    //   )
    // }

  const resetComplaintStatus = async ({ id }) => {
    try {
      resetComplaintStatusApi({ id })
      setAssignedComplaintList(
        assignedComplaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 1 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const processingComplaintStatus = async ({ id }) => {
    try {
      setAssignedComplaintList(
        assignedComplaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 5 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const processedComplaintStatus = async ({ id }) => {
    try {
      setAssignedComplaintList(
        assignedComplaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 8 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const returnedComplaintStatus = async ({ id }) => {
    try {
      setAssignedComplaintList(
        assignedComplaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 6 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }
  

  const init = () => {
    setOperationFilter({ ...initialOperationFilter})
    setoperationPagination({ ...initialOperationPagination})
    setFilter({ ...initialFilter })
    setPagination({ ...initialPagination })
    setcomplaintIdFP({...initialPaginationComplaint})
  }

  const providerValue = {
    init,
    assignedComplaintList,
    complaintOperationList,
    trashTypes,
    natures,
    filter,
    operationFilter,
    statuses: [
        { id: 4, label: t('statuses.assigner')},
        { id: 5, label: t('statuses.on_treatment')},
        { id: 6, label: t('statuses.returned')},
        { id: 8, label: t('statuses.treated')},
        { id: 10, label: t('statuses.unresolved')},
      ],
    timeLimits: [
        {id: 1, label: t('timeLimit.oneDay')},
        {id: 2, label: t('timeLimit.twoDays')},
        {id: 3, label: t('timeLimit.threeDays')},
        {id: 4, label: t('timeLimit.fourDays')},
        {id: 5, label: t('timeLimit.fiveDays')}
      ],
    returnCommentaries: [
        { id: 1, label: t('returnCommentaries.commentaryOne')},
        { id: 2, label: t('returnCommentaries.commentaryTwo')}, 
        { id: 3, label: t('returnCommentaries.commentaryThree')},
        { id: 4, label: t('returnCommentaries.commentaryFour')},
        { id: 5, label: t('returnCommentaries.commentaryFive')}
      ],
      trashTypesPopOver: [
        {id: 1, label: t('trashTypes.dechet_inertes')},
        {id: 2, label: t('trashTypes.dechet_vert')},
        {id: 3, label: t('trashTypes.dechet_menagers_assimile')},
        {id: 4, label: t('trashTypes.dechet_encombrant')},
        {id: 5, label: t('trashTypes.dechet_mixte')},
      ],
      naturesPopOver: [
        {id: 1, label: t('natures.depotoire_sauvage')},
        {id: 2, label: t('natures.collect_default')},
      ],
    pagination,
    operationPagination,
    isLoading,
    handleFilter,
    handleOperationFilter,
    handlePagination,
    handleOperationPagination,
    processedComplaint,
    startProcessingComplaint,
    getAssignedComplaintList,
    // changeAssignedComplaintStatus,
    returnComplaint,
    resetComplaintStatus,
    processingComplaintStatus,
    returnedComplaintStatus,
    processedComplaintStatus,
    handleOperationPaginationRefresh,
  }

  useEffect(() => {
    if (natures.length > 0 && trashTypes.length > 0) {
      getAssignedComplaintList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, pagination.take, pagination.skip, natures, trashTypes])

  useEffect(() => {
    getNatures()
    getTrashTypes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getComplaintOperationList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [complaintIdFP.id, operationPagination.take, operationPagination.skip, operationPagination.currentPage, operationPagination.total])

  return (
    <AssignComplaintsContext.Provider value={providerValue}>
      {children}
    </AssignComplaintsContext.Provider>
  )
}  

AssignComplaintsProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useAssignedComplaints = () => {
  const context = useContext(AssignComplaintsContext)
  if (context === undefined) {
    throw new Error('useAssignedComplaints must be used within a AssignedComplaintsProvider')
  }
  return context
}
